import { render, staticRenderFns } from "./FormLink.vue?vue&type=template&id=14f72330&scoped=true"
import script from "./FormLink.vue?vue&type=script&lang=js"
export * from "./FormLink.vue?vue&type=script&lang=js"
import style0 from "./FormLink.vue?vue&type=style&index=0&id=14f72330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f72330",
  null
  
)

export default component.exports